import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Checkbox, Button, DialogActions } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import FormControlLabel from '@mui/material/FormControlLabel';
import HeaderBackground from 'common/assets/dialog-stripes.svg';

interface Props {
	open: boolean;
	header: string;
	checkBoxLabel: string;
	additionalText?: JSX.Element;
	cancelButton: string;
	acceptButton: string;
	onCancel: () => void;
	onAccept: () => void;
}

const TimeZoneChangeDialog = (props: Props) => {
	const {
		open,
		header,
		checkBoxLabel,
		additionalText,
		cancelButton,
		acceptButton,
		onCancel,
		onAccept,
	} = props;
	const [consentToChangeTimezone, setConsentToChangeTimezone] = useState<boolean>(false);
	const classes = useStyles();

	const handleCancel = () => {
		setConsentToChangeTimezone(false);
		onCancel();
	};

	const handleAccept = () => {
		setConsentToChangeTimezone(false);
		onAccept();
	};

	return (
		<Dialog onClose={handleCancel} open={open} maxWidth="sm" fullWidth>
			<DialogTitle id="confirmationDialogTitle" classes={{ root: classes.title }}>
				{header}
			</DialogTitle>
			<DialogContent classes={{ root: classes.content }}>
				{additionalText}
				<FormControlLabel
					value="end"
					control={
						<Checkbox
							onChange={() => setConsentToChangeTimezone(!consentToChangeTimezone)}
							color="secondary"
						/>
					}
					classes={{
						label: classes.label,
					}}
					label={checkBoxLabel}
					labelPlacement="end"
				/>
			</DialogContent>
			<DialogActions>
				<Button variant="text" color="secondary" onClick={handleCancel}>
					{cancelButton}
				</Button>
				<Button
					variant="contained"
					color="primary"
					disabled={!consentToChangeTimezone}
					onClick={handleAccept}
				>
					{acceptButton}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

const useStyles = makeStyles((theme) => ({
	title: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.primary.contrastText,
		backgroundImage: `url("${HeaderBackground}")`,
	},
	content: {
		color: theme.palette.text.primary,
		display: 'flex',
		flexWrap: 'wrap',
		padding: theme.spacing(4, 4),
	},
	label: {
		marginTop: theme.spacing(2),
	},
	buttonWrapper: {
		paddingTop: theme.spacing(2),
	},
}));

export default TimeZoneChangeDialog;
